import {
  Model,
} from '@vuex-orm/core';

export default class extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'wikipediaPage'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
    return {
      id: this.number(0),
      name: this.string(''),
      last_fetch_performed_at: this.string(''),
    };
  }

  static methodConf = {
    http: {
      url: process.env.VUE_APP_APIS_FETCHER_ADMIN,
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/wikipediaPages',
          method: 'get',
        },
      },
      $get: {
        name: 'get',
        http: {
          url: '/wikipediaPages/:id',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/wikipediaPages',
          method: 'post',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/wikipediaPages/:id',
          method: 'put',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/wikipediaPages/:id',
          method: 'delete',
        },
      },
    },
  }
}
